import axios from "axios";
import {useSelector} from "react-redux";

const useAxios = (includeHeaders = false) => {
    const {session} = useSelector((state) => ({
        session: state.morpheus.session,
    }));

    const headers = {
        "X-RedPill-Store": session.store,
        "X-RedPill-Broker": session.broker,
        "X-RedPill-Authenticator": session.authenticator,
    };

    let settings = {};
    if (includeHeaders) {
        settings.headers = headers;
    }

    const instance = axios.create(settings);

    return {instance};
};

export default useAxios;

